<template>
		<div class="test-wrap">
			<div class="back" @click="goBack"><img src="../assets/icon／arrow-right@2x.png"> 返回 </div>
			<div class="test-main">
				<div class="test-info">
					<img class="logo" src="../assets/logo.png" alt="" />
					<div class="num-info">
						<div class="">本次练习题共计8套</div>
						<div><span class="num">0</span> / 8</div>
					</div>
					<div class="test-info-title">英语语法练习</div>
					<div class="test-info-detail">这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍这是介绍</div>
					<div class="test-info-warning">
						<div class="test-info-warning-title">考试注意事项及说明</div>
						<div class="test-info-warning-li">· 每套试卷含阅读与写作、听力以及口语三部分。三部分试卷依次完成</div>
						<div class="test-info-warning-li">· 注意每份试卷的时间和题量。</div>
						<div class="test-info-warning-li">· 考试设有倒计时，请合理分配时间.</div>
						<div class="test-info-warning-li">· 每份试卷只能答一次。未提交答题卡，中途退出后可继续，但必须在剩余时间内完成</div>
						<div class="test-info-warning-li">· 所有答案填写在答题卡上，并自行提交答题卡，答题卡提交后不可修改</div>
						<div class="test-info-warning-li">· 考后可查错题解析，未完成的试卷除外。已完成的试卷可随时查看复习。</div>
					</div>
				</div>
				<div class="test-list">
					<div class="test-list-title">英语语法练习</div>
					<div class="test-list-item" v-for="(item,index) in testList" :key="index">
						<div class="test-list-name">{{item.name}}</div>
<!-- 						<div class="test-list-btn" @click="goDetail" :class="item.isDone?'btn-act':''">
							<div class="test-list-icon listen-icon"></div>
							<div class="test-type">听力</div>
							<div class="bingo"></div>
						</div>
						<div class="test-list-btn" :class="item.isDone?'btn-act':''">
							<div class="test-list-icon speak-icon"></div>
							<div class="test-type">口语</div>
							<div class="bingo"></div>
						</div>
						<div class="test-list-btn" :class="item.isDone?'btn-act':''">
							<div class="test-list-icon reading-icon"></div>
							<div class="test-type">阅读</div>
							<div class="bingo"></div>
						</div> -->
						<div class="test-list-btn" @click="goDetail" :class="item.isDone?'btn-act':''">
							<div class="test-list-icon reading-icon"></div>
							<div class="test-type">练习</div>
							<div class="bingo"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>
<script>

export default {
	name: 'index',

	components: {},

	data(){
		return {
			testList:[
				{
					name:'TEST 01',
					isDone:true
				},
				{
					name:'TEST 02',
				},
				{
					name:'TEST 03',
				},
				{
					name:'TEST 04',
				},
				{
					name:'TEST 05',
				},
				{
					name:'TEST 06',
				},
				{
					name:'TEST 07',
				},
				{
					name:'TEST 08',
				},
			],
		}
	},

	created(){

	},
	mounted() {

	},

	computed: {

	},
	watch: {

	},
	methods: {
		goDetail(){
			this.$router.push({  //核心语句
			  path:'/testDetail',   //跳转的路径
			  query:{}
			})
		},
		goBack(){
			this.$router.back()
		}
	}
}
</script>

<style lang="scss" scoped>
.test-wrap{
	padding: 1.5rem 2rem 2rem;
	.back{
		display: flex;
		font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
		font-weight: 500;
		font-size: 1.6rem;
		color: rgba(0,0,0,0.8);
		line-height: 1.88rem;
		margin-bottom: 1.5rem;
		text-align: left;
		img{
			width: 1.85rem;
			height: 1.85rem;
			transform: rotate(180deg);
		}
	}
	.test-main{
		display: flex;
		.test-info{
			width: 29.55rem;
			height: 51rem;
			background: #FFFFFF;
			border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
			padding: 1.5rem;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-right: 1.5rem;
			.logo{
				margin-top: 1.5rem;
				width: 12.25rem;
				height: 11.6rem;
				margin-bottom: 1.4rem;
			}
			.num-info{
				width: 26.55rem;
				display: flex;
				justify-content: space-between;
				align-items: center;
				background: #FFFFFF;
				border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
				border: 0.05rem solid #E0E0E0;
				padding: 0.75rem 1rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1rem;
				color: #1D1D1D;
				margin-bottom: 1.2rem;
				box-sizing: border-box;
				.num{
					color: rgb(100, 45, 113);
					font-size: 1.6rem;
					font-weight: bold;
				}
			}
			.test-info-title{
				width: 26.55rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1.2rem;
				color: #1D1D1D;
				line-height: 1rem;
				text-align: l;
				margin-bottom: 0.8rem;
			}
			.test-info-detail{
				width: 26.55rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 0.8rem;
				color: #515154;
				line-height: 1.15rem;
				text-align: justified;
			}
			.test-info-warning{
				margin-top: auto;
				// width: 26.55rem;
				// height: 11.7rem;
				background: #F8F9FB;
				border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
				padding: 1rem;
				box-sizing: border-box;
				.test-info-warning-title{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 1rem;
					color: #1D1D1D;
					line-height: 1rem;
					text-align: left;
					margin-bottom: 0.8rem;
				}
				.test-info-warning-li{
					margin-bottom: 0.4rem;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: bold;
					font-size: 0.7rem;
					color: #74798C;
					line-height: 1.15rem;
					text-align: justified;
				}
			}
		}
		.test-list{
			width: 64.95rem;
			height: 51rem;
			background: #FFFFFF;
			border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
			padding: 2.5rem;
			box-sizing: border-box;
			.test-list-title{
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1.6rem;
				color: #000000;
				line-height: 1.7rem;
				margin-bottom: 2rem;
			}
			.test-list-item{
				width: 59.95rem;
				height: 3.5rem;
				background: #FFFFFF;
				border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
				border: 0.05rem solid #E0E0E0;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				padding: 0 1rem;
				margin-bottom: 1rem;
				.test-list-name{
					margin-right: auto;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 1rem;
					color: #1D1D1D;
				}
				.test-list-btn{
					height: 2rem;
					border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
					border: 0.05rem solid rgb(100, 45, 113);
					color: rgb(100, 45, 113);
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 0 0.75rem;
					margin-left: 1.5rem;
					.test-list-icon{
						width: 1rem;
						height: 1rem;
						background-repeat: no-repeat;
						background-size: contain;
					}
					.listen-icon{
						background-image: url(../assets/listen-icon.png);
					}
					.speak-icon{
						background-image: url(../assets/speak-icon.png);
					}
					.reading-icon{
						background-image: url(../assets/reading-icon.png);
					}
					.test-type{
						margin-left: 0.5rem;
					}
					.bingo{
						visibility: hidden;
						margin-left: 0.5rem;
						width: 0.9rem;
						height: 0.66rem;
						background-repeat: no-repeat;
						background-size: contain;
					}
				}
				.btn-act{
					background: rgb(100, 45, 113);
					color: #fff;
					.listen-icon{
						background-image: url(../assets/listen-icon-no.png);
					}
					.speak-icon{
						background-image: url(../assets/speak-icon-no.png);
					}
					.reading-icon{
						background-image: url(../assets/reading-icon-no.png);
					}
					.bingo{
						visibility: visible;
						margin-left: 0.5rem;
						width: 0.9rem;
						height: 0.66rem;
						background-image: url(../assets/bingo.png);
					}
				}
			}
		}
		// <div class="test-list">
		// 	<div class="test-list-title">英语语法练习</div>
		// 	<div class="test-list-item" v-for="(item,index) in testList" :key="index">
		// 		<div class="test-list-name">{{item.name}}</div>
		// 		<div class="test-list-btn" :class="item.isDone?'btn-act':''">
		// 			<img src="../assets/listen-icon.png" alt="" />
		// 			<div class="test-list">听力</div>
		// 			<img class="bingo" src="../assets/bingo.png" alt="" />
		// 		</div>
	}
}
</style>
